// Rot (docs/04 §11): after G_ROT, fruit that has appeared ROT_AGE times turns Rotten.
// Runs in step 4 (LAND) right after ages are incremented, before on-land symbol hooks.
import { B } from '../content/balance';
import type { GridCellView } from '../content/defs';
import { SYMBOLS } from '../content/registry';
import type { Modifiers } from './modifiers';
import type { Rng } from './rng';
import type { GameEvent } from './types';

export function rotActive(mods: Modifiers): boolean {
  return mods.symbolGates.has('rot') && !mods.rotNever;
}

/** Appearances before a fruit rots. */
export function rotThreshold(mods: Modifiers): number {
  return Math.round((B.ROT_AGE + mods.rotAgeAdd) * mods.rotSlow);
}

/** Appearances left before this defId rots, or null if it never rots (UI helper). */
export function rotsIn(defId: string, age: number, mods: Modifiers): number | null {
  if (!rotActive(mods) || !SYMBOLS.get(defId)?.rotsInto) return null;
  return Math.max(0, rotThreshold(mods) - age);
}

export function rotCheck(cells: GridCellView[], mods: Modifiers, rng: Rng, events: GameEvent[]): void {
  if (!rotActive(mods)) return;
  const threshold = rotThreshold(mods);
  const done = new Set<number>();
  for (const v of cells) {
    const { inst } = v;
    const into = SYMBOLS.get(inst.defId)?.rotsInto;
    if (!into || done.has(inst.uid) || inst.age < threshold) continue;
    done.add(inst.uid);
    const from = inst.defId;
    const to = mods.compostChance > 0 && rng.chance(mods.compostChance) ? 'seed' : into;
    inst.defId = to;
    inst.age = 0;
    inst.bonusValue = 0;
    events.push({ e: 'SYMBOL_TRANSFORMED', uid: inst.uid, cell: v.cell, from, to });
  }
}
